export default __webpack_public_path__ + "static/media/azure.81f2252b.jpeg";